// components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const user =
    JSON.parse(localStorage.getItem("user")) ||
    JSON.parse(sessionStorage.getItem("user"));

  if (!user) {
    return <Navigate to="/" />;
  }

  // if (!user.termsAccepted) {
  //   return <Navigate to="/" />; // Redirect to Login to accept Disclaimer
  // }

  return children;
};

export default ProtectedRoute;

